import { createSelector } from 'reselect';

export const getActivationCode = createSelector(
    (state) => state.paymentDetails.method,
    (method = {}) => {
        const activation_code = method.activation_code || {};
        return {
            timeToRenew: activation_code.time_to_renew || 0,
            attemptsLeft: activation_code.attempts_left || 0,
            methodPaymentId: method.id
        };
    }
);
